import { render, staticRenderFns } from "./GenerateInform.vue?vue&type=template&id=04efa990&scoped=true&"
import script from "./GenerateInform.vue?vue&type=script&lang=js&"
export * from "./GenerateInform.vue?vue&type=script&lang=js&"
import style0 from "./GenerateInform.vue?vue&type=style&index=0&id=04efa990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efa990",
  null
  
)

export default component.exports